export default "/static/empty/no-payment.png"